/**
 * Simple in-memory cache with TTL for frequently-accessed data
 * Used for static-ish data like partners list, session task definitions
 */

const cache = new Map()

/**
 * Get cached data if not expired
 * @param {string} key - Cache key
 * @returns {any|null} Cached data or null if expired/missing
 */
export function getCache(key) {
  const entry = cache.get(key)
  if (!entry) return null

  if (Date.now() > entry.expiresAt) {
    cache.delete(key)
    return null
  }

  return entry.data
}

/**
 * Set cache with TTL
 * @param {string} key - Cache key
 * @param {any} data - Data to cache
 * @param {number} ttlMs - Time to live in milliseconds (default 5 min)
 */
export function setCache(key, data, ttlMs = 5 * 60 * 1000) {
  cache.set(key, {
    data,
    expiresAt: Date.now() + ttlMs
  })
}

/**
 * Clear specific cache key
 * @param {string} key - Cache key to clear
 */
export function clearCache(key) {
  cache.delete(key)
}

/**
 * Clear all cache entries matching a prefix
 * @param {string} prefix - Key prefix to match
 */
export function clearCacheByPrefix(prefix) {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) {
      cache.delete(key)
    }
  }
}

/**
 * Clear entire cache
 */
export function clearAllCache() {
  cache.clear()
}

// Cache keys for common data
export const CacheKeys = {
  PARTNERS: 'partners',
  SESSION_TASK_DEFS: 'session_task_definitions',
  ACTIVE_CAMPAIGNS: 'active_campaigns',
  SYSTEM_CONFIG: 'system_config'
}

// TTL values
export const CacheTTL = {
  SHORT: 30 * 1000,      // 30 seconds
  MEDIUM: 5 * 60 * 1000, // 5 minutes
  LONG: 30 * 60 * 1000   // 30 minutes
}
